// extracted by mini-css-extract-plugin
export var container = "_g0-0";
export var content = "_g0-3";
export var customerTitle = "_g0-4";
export var empty = "_g0-5";
export var gray = "_g0-6";
export var header = "_g0-7";
export var info = "_g0-8";
export var loading = "_g0-2";
export var loadingCard = "_g0-9";
export var oneLine = "_g0-a";
export var personName = "_g0-e";
export var pillContainer = "_g0-b";
export var selected = "_g0-1";
export var text = "_g0-c";
export var twoLines = "_g0-d";
export var unread = "_g0-f";
export var unreadIndicator = "_g0-g";